// React
import { CSSProperties, ReactElement } from 'react';
// Modules
import classNames from 'classnames/bind';
// Utils
import { rem } from '@utmb/utils/font';
// Styles
import styles from './my-table.module.scss';

export interface MyTableCellProps {
    children: any;
    className?: string;
    /** Based on a grid of 12 columns. */
    column?: number;
    hiddenOnMobile?: boolean;
    paddingHidden?: boolean;
    label?: string;
    height?: number;
}

const cx = classNames.bind(styles);

export const MyTableCell = (props: MyTableCellProps): ReactElement => {
    const { children, className, column, hiddenOnMobile = false, paddingHidden = false, label, height } = props;

    // Define the CSS properties
    const style: CSSProperties = {};

    if (height) style.minHeight = rem(height);

    const classesCSS = cx(className, styles.cell, column && `col-${Math.min(column, 12)}`, {
        hide_mobile: hiddenOnMobile,
        remove_padding: paddingHidden,
    });

    return (
        <div className={classesCSS} style={style} data-label={label}>
            {children}
        </div>
    );
};
